// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"177":"home","942":"article"}[chunkId] + "." + {"177":"e78798c0","942":"11bcfc36"}[chunkId] + ".chunk.css";
};